// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12isO","controls":"styles_controls__qzzjF","charLimit":"styles_charLimit__cVmaZ","input":"styles_input__3TIP3","send":"styles_send__3I2Va"};